import { request } from '@/utils/request.js'

/**
 * 在线咨询（对应 lvtongmeng-admin 的 src/api/webman.js）
 * 说明：这些接口调用频繁，统一关掉全屏 loading，避免页面闪烁
 */

// 推送配置（登录成功后调用，返回 { url, app_key }，给 utils/webman-push.js 用）
export function getWsToken() {
  return request({
    url: '/admin/im/wstoken',
    method: 'post',
    showLoading: false
  })
}

// 咨询列表（status：1 待接入，3 已结束）
export function getChatLists(data) {
  return request({
    url: '/admin/chat/lists',
    method: 'post',
    showLoading: false,
    data
  })
}

// 咨询中列表（无参数，不分页）
export function getChatOnList(data) {
  return request({
    url: '/admin/chat/onLists',
    method: 'post',
    showLoading: false,
    data
  })
}

// 咨询详情（点击列表项时调用，传 id）
export function getChatDetail(data) {
  return request({
    url: '/admin/chat/detail',
    method: 'post',
    showLoading: false,
    data
  })
}

// 聊天记录（点击列表项时调用，传 id/page/limit）
export function getChatRecord(data) {
  return request({
    url: '/admin/chat/record',
    method: 'post',
    showLoading: false,
    data
  })
}

// 立即接入（status：2 接入，传 id/status）
export function updateChatStatus(data) {
  return request({
    url: '/admin/chat/status',
    method: 'post',
    showLoading: false,
    data
  })
}

// 处理未读数
// （发送传 user_unread_total：小程序端未读数量）
// （客服端已读传 unread_total：0 清空）
export function updateUnread(data) {
  return request({
    url: '/admin/chat/unread',
    method: 'post',
    showLoading: false,
    data
  })
}

// 发送聊天消息
export function sendChatMessage(data) {
  return request({
    url: '/admin/im/send',
    method: 'post',
    showLoading: false,
    data
  })
}

// 入驻商户详情（右栏商家信息）
export function getMerchantDetail(data) {
  return request({
    url: '/admin/settle/detail',
    method: 'post',
    showLoading: false,
    data
  })
}

// 获取七牛云 token
export function getQnToken() {
  return request({
    url: '/common/upload_file/qnToken',
    method: 'get',
    showLoading: false
  })
}

// 说明：右栏资源列表接口不在本文件，合同 tab 直接复用 api/goods/goods.js 的 getContractGoodsList
